import { Pagination } from 'interfaces/common';
import {
  GET_LIST_AWARDS, GET_AWARD_DETAILS, AwardsAndAccreditationActionTypes
} from './actionType';

interface EventAndClassesState {
  data: any;
  details: any;
  pagination: Pagination;
}

const initState: EventAndClassesState = {
  data: [],
  details: {},
  pagination: {
    count: 0,
    limit: 10,
    offset: 0,
    order: 'id',
    page: 1,
    total_page: 1,
    keyword: '',
    sort: 'desc',
    category: '',
    is_publish: 'true',
  }
};

const AwardsAndAccreditationReducer = (state = initState, action: AwardsAndAccreditationActionTypes) => {
  switch (action.type) {
    case GET_LIST_AWARDS:
      return {
        ...state,
        data: action.data,
        pagination: action.pagination
      };
    case GET_AWARD_DETAILS:
      return {
        ...state,
        details: action.details
      };
    default:
      return state;
  }
};

export default AwardsAndAccreditationReducer;